import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import * as _a from '@/lib/api';
import queryClient from '@/lib/queryClient';

export const useChannelPosts = (cid: string) => {
  let queryKey: string[] = [];

  const infiniteQuery = (sort: string) => {
    queryKey = [`channels`, cid, `channel_posts`, sort];
    return useInfiniteQuery({
      queryKey: queryKey,
      queryFn: ({ pageParam }) => _a.channelPosts({ cid, sort, page: pageParam, per: 30 }),
      initialPageParam: 1,
      getNextPageParam: (resp) => {
        if (resp.has_next) {
          return resp.page + 1;
        } else {
          return undefined;
        }
      },
    });
  };

  const invalidate = () => {
    return queryClient.invalidateQueries({ queryKey });
  };

  return { infiniteQuery, invalidate };
};
